import SpriteSymbol from "../../../../../../../shared/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../config/webpack/loaders/svg-sprite/utils/sprite";
var symbol = new SpriteSymbol({
  "id": "icon__arrow-plus",
  "use": "icon__arrow-plus-usage",
  "viewBox": "0 0 8 14",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 8 14\" id=\"icon__arrow-plus\"><path d=\"m1 1 6 6-6 6\" stroke=\"#000\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol